import axios from 'axios';
import { API_URL } from '../config/api';
import SessionService from './SessionService';

const authHeaders = () => {
  const token = SessionService.getToken();
  if (!token) throw new Error('Authentication token not found');
  return { Authorization: `Bearer ${token}` };
};

export type MetaReplyChannel = 'instagram' | 'messenger';

/** open · human_agent_only (fora das 24 h, só resposta humana aprovada pela Meta) · closed */
export type MetaWindowState = 'open' | 'human_agent_only' | 'closed';

export interface MetaWindow {
  state: MetaWindowState;
  untilUtc: string | null;
  /** "Instagram · @conta" */
  accountLabel: string;
  reason: string;
  /** Limite do texto em bytes UTF-8 (1000 no Instagram); nulo = sem limite conhecido. */
  maxBytes: number | null;
}

export interface MetaSendInput {
  sectorId: number;
  contactId: number;
  channel: MetaReplyChannel;
  text: string;
  idempotencyKey: string;
}

export interface MetaSendResult {
  messageId: number;
  /** true = modo local seguro: a resposta foi só capturada em arquivo. */
  captured: boolean;
}

export const getMetaWindow = async (
  sectorId: number,
  contactId: number,
  channel: MetaReplyChannel,
): Promise<MetaWindow> => {
  const response = await axios.get<MetaWindow>(`${API_URL}/meta/messages/window`, {
    params: { sectorId, contactId, channel },
    headers: authHeaders(),
  });
  return response.data;
};

export const sendMetaMessage = async (input: MetaSendInput): Promise<MetaSendResult> => {
  const response = await axios.post<MetaSendResult>(`${API_URL}/meta/messages/send`, input, { headers: authHeaders() });
  return response.data;
};
